import { render, staticRenderFns } from "./MatchingViz.vue?vue&type=template&id=7b561946&scoped=true"
import script from "./MatchingViz.vue?vue&type=script&lang=js"
export * from "./MatchingViz.vue?vue&type=script&lang=js"
import style0 from "./MatchingViz.vue?vue&type=style&index=0&id=7b561946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b561946",
  null
  
)

export default component.exports